var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9479 7.0968C17.9479 7.0968 19.4268 11.9192 17.245 14.4538C15.064 16.9885 9.91508 21.5932 12.0068 30C12.0068 30 10.9339 26.4662 15.5464 22.8785C20.1589 19.2909 23.0608 14.5927 17.9479 7.0968Z",
    fill: "#7FB444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9964 29.9327C11.9964 29.9327 8.94854 21.406 10.6643 18.0865C12.3809 14.767 19.4069 8.76983 17.583 6.41345C17.583 6.41345 19.9966 10.1083 18.0654 13.696C16.1351 17.2828 10.387 20.1344 11.9964 29.9327Z",
    fill: "#9CC73C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62305 0C6.62305 0 -10.9257 10.4135 11.1077 29.6553C11.1077 29.6553 1.94618 15.6455 17.084 7.15483C17.084 7.15483 13.9186 5.72386 8.55422 11.8256C3.18899 17.9265 2.75126 10.8094 3.04737 7.89002C3.20187 6.36137 4.13484 2.80024 6.62305 0Z",
    fill: "#842D73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7977 10.0183C8.01241 9.11059 7.44935 8.20095 6.54009 7.98661C5.63082 7.77226 4.71967 8.33438 4.50497 9.24212C4.29026 10.1499 4.85332 11.0595 5.76258 11.2738C6.67184 11.4882 7.583 10.9261 7.7977 10.0183Z",
    fill: "#842D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f2ba3e02c0adddf09a6428757f848162.svg";
export { ForwardRef as ReactComponent };